window.VH = window.VH === undefined ? {} : window.VH;
VH.AjaxLoadContent = {
    init : function init() {
        $('.ajaxLoadContent').each(function () {
            let t = $(this),
                loaded = t.data('ajax-load-content-loaded');

            if (loaded === undefined) {
                $.get(t.data('url'), {}, function (result) {
                    t.html(result);
                    VH.TomSelect.init();
                    t.data('ajax-load-content-loaded', true);
                    t.trigger('AjaxLoadContent.loaded');
                });
            }
        });
    }
};